import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Subject ,  Observable } from 'rxjs';
import { HttpClientModule } from '@angular/common/http';
import { logbaseService } from '../../services/logbase.service';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { dateFormatPipe } from "../../pipes/dateFormatPipe";
import { NgbModal, ModalDismissReasons, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator} from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
export interface NotificationData{
  partNumber:any;
  supplierCode:any;
  partName:any;
  assignedDate:any;
  lastdate:any;
  duedate:any;

}

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
  displayedColumns = ['partNumber', 'supplierCode', 'partName', 'assignedDate','lastDate','dueDate'];
  dataSource: MatTableDataSource<NotificationData[]>;

  notificationCount;
  modalRef: NgbModalRef;
  parts;
  datePipe = new DatePipe("en-US");
  lineNos: any;
  userRoleId: any;
  userSuppCode: any;
  userDetJson: any;
  userDetails: string;
  partStatus;
  searchText = ''
  public rows: Array<any> = [];
  public columns: any;
  public page: number = 1;
  public itemsPerPage: number = 10;
  public maxSize: number = 5;
  public numPages: number = 1;
  public length: number = 0;
  private data: Array<any> = [];
  public config: any
  lineNoFilter: any;
  supPoint: any;
  suppCodeList: any[];
  dropdownSettings2: any;
  dropdownSettings: any;
  lineNoList: any[];

  public constructor(private modalService: NgbModal,
    private logbaseService: logbaseService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService) {
    this.length = this.data.length;
    this.notificationCount = {
      NewPart: 0,
      Rejected: 0,
      Awating: 0,
      Approved: 0
    }
    this.columns = [
      { title: this.translate.instant("PARTNO"), name: "partNumber", sort: 'asc' },
      { title: this.translate.instant("SUPPLIERCODE"), name: "supplierCode", sort: 'asc' },
      { title: this.translate.instant("PARTNAME"), name: "partName", sort: 'asc' },
      { title: this.translate.instant("ASSIGNEDDATE"), name: "assignedDate", sort: 'asc' },
      { title: this.translate.instant("LASTUPDATE"), name: "lastdate", sort: 'asc' },
      { title: this.translate.instant("DUEDATE"), name: "duedate", sort: 'asc' }
    ];
    this.config = {
      paging: true,
      sorting: { columns: this.columns },
      filtering: { filterString: '' },
      className: ['table-striped', 'table-bordered']
    };
    this.userDetails = localStorage.getItem("userDetails");
    this.userDetJson = JSON.parse(this.userDetails);
    this.userRoleId = this.userDetJson.userRoleMappings[0].roleId;
    this.userSuppCode = this.userDetJson.supplierCode;
    this.lineNos = this.userDetJson.lineNumbers;
  }

  ngOnInit() {

    if (this.userRoleId == 1) {
      this.getAllCountPartWise();
    }

    this.dropdownSettings2 = {
      idField:'id',
      textField:'itemName',
      singleSelection: false,
      text: this.translate.instant('Select'),
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      classes: "custom-class",
      itemsShowLimit: 2,
      // enableCheckAll: true,
      // enableSearchFilter: true,
      // limitSelection: 10
    };
    // Angular2 multi select settings and config
    this.dropdownSettings = {
      idField:'id',
      textField:'itemName',
      singleSelection: false,
      text: this.translate.instant('Select'),
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      classes: "custom-class",
      badgeShowLimit: 2,
      enableCheckAll: true,
      enableSearchFilter: true,
      limitSelection: 10
    };

    //load supplier code or line number based on user login
    if (this.userRoleId == 4) {
      this.getLineNos();
    } else {
      this.getSupplierCode();
    }

  };

  getSupplierCode() {
    this.spinner.show();

    //Get all supplier codes starts
    var supplierCodes;
    this.logbaseService.getSupplierMasterData().subscribe(result => {
      supplierCodes = result.response;
      let suppCodeListArr = [];
      supplierCodes.forEach(function (value, key) {
        suppCodeListArr.push({ id: key + 1, itemName: value.supplierCode });
      });
      this.suppCodeList = suppCodeListArr;
      this.spinner.hide();

    });
    //Get all supplier codes ends
  };

  getLineNos() {
    this.spinner.show();
    let lineNoArr = [];
    this.logbaseService.getLineNumbers().subscribe(result => {
      result.response.forEach(function (value, key) {
        lineNoArr.push({ id: key + 1, itemName: value.lineNumber });
      });
      this.lineNoList = lineNoArr;
      this.spinner.hide();
    });
  }

  getAllCountPartWise() {

    var selectSuppCode = [], userSuppCode, lineNos, selectLineNos = [];
    // Get Line number/next process selected by operation user
    if (this.userRoleId != 4) {
      lineNos = [];
    } else {
      if (this.lineNoFilter) {
        this.lineNoFilter.forEach(function (value, key) {
          selectLineNos.push(value.itemName);
        });

        if (selectLineNos.length > 0) {
          lineNos = selectLineNos;
        }
      }
    }

    if (lineNos == null) {
      lineNos = [];
    }

    //Get Selected Supplier Code
    if (this.userRoleId == 1) {
      userSuppCode = this.userDetJson.supplierCode;
    } else {
      if (this.supPoint) {
        this.supPoint.forEach(function (value, key) {
          selectSuppCode.push(value.itemName);
        });

        if (selectSuppCode.length > 0) {
          userSuppCode = selectSuppCode;
        }
      }
    }

    if (userSuppCode == null) {
      userSuppCode = [];
    }

    let dataToSend = {
      filteredDeliveryPoints: [],
      filteredLineNumbers: [],
      filteredSupplierCode: [],
      filteredSupplierName: [],
      lineNumbers: lineNos,
      pageNum: 0,
      partStatus: 'new',
      roleId: this.userRoleId,
      searchValue: '',
      size: this.itemsPerPage,
      sortColumn: '',
      sortType: 'ASC',
      supplierCodes: userSuppCode
    }

    this.spinner.show();

    let dataToSendRejectd = { filteredDeliveryPoints: [], filteredLineNumbers: [], filteredSupplierCode: [], filteredSupplierName: [], lineNumbers: lineNos, pageNum: 0, partStatus: 'rejected', roleId: this.userRoleId, searchValue: '', size: this.itemsPerPage, sortColumn: '', sortType: 'ASC', supplierCodes: userSuppCode }
    let dataToSendunderReview = { filteredDeliveryPoints: [], filteredLineNumbers: [], filteredSupplierCode: [], filteredSupplierName: [], lineNumbers: lineNos, pageNum: 0, partStatus: 'underReview', roleId: this.userRoleId, searchValue: '', size: this.itemsPerPage, sortColumn: '', sortType: 'ASC', supplierCodes: userSuppCode }
    let dataToSendApproved = { filteredDeliveryPoints: [], filteredLineNumbers: [], filteredSupplierCode: [], filteredSupplierName: [], lineNumbers: lineNos, pageNum: 0, partStatus: 'approved', roleId: this.userRoleId, searchValue: '', size: this.itemsPerPage, sortColumn: '', sortType: 'ASC', supplierCodes: userSuppCode }
    this.logbaseService.partStatusWtPaging(dataToSend).subscribe(result => {
      let newparts;
      newparts = result;
      this.notificationCount.NewPart = newparts.response.totalElements;
      this.logbaseService.partStatusWtPaging(dataToSendRejectd).subscribe(rejectedresult => {
        let rejectedparts;
        rejectedparts = rejectedresult;
        this.notificationCount.Rejected = rejectedparts.response.totalElements;
        this.logbaseService.partStatusWtPaging(dataToSendunderReview).subscribe(underReviewresult => {
          let Awatingparts;
          Awatingparts = underReviewresult;
          this.notificationCount.Awating = Awatingparts.response.totalElements;
          this.logbaseService.partStatusWtPaging(dataToSendApproved).subscribe(approvedresult => {
            let ApprovedParts;
            ApprovedParts = approvedresult;
            this.notificationCount.Approved = ApprovedParts.response.totalElements;
          });
        });
      });
      this.spinner.hide();

    });
  }

  openModal(detailPage, partStatus, pageNo) {
    this.searchText = ''
    this.partStatus = partStatus
    this.getPartWiseData(partStatus, pageNo);
    this.modalRef = this.modalService.open(detailPage, {
      size: "lg",
      windowClass: "detail-modal",backdrop:false
    });
    this.modalRef.result.then(
      () => {
        //When user closes
        // Reset Approved parts details and search string when modal is closed
        // this.searchString = "";
        // if (this.searchAppParts) {
        //   this.searchAppParts.length = 0;
        // }

        // this.partConfig.filtering.filterString = "";


        // this.initPagingtable();
        // // Call again to reintialize and rerender
        // this.initPagingtable();
      },
      () => {
        //Backdrop click
        // Reset Approved parts details and search string when modal is closed
        // this.searchString = "";
        // if (this.searchAppParts) {
        //   this.searchAppParts.length = 0;
        // }

        // this.partConfig.filtering.filterString = "";
        // this.initPagingtable();
      }
    );


  }

  getPartWiseData(partStatus, pageNo) {

    this.columns = [
      { title: this.translate.instant("PARTNO"), name: "partNumber" },
      { title: this.translate.instant("SUPPLIERCODE"), name: "supplierCode" },
      { title: this.translate.instant("PARTNAME"), name: "partName" },
      { title: this.translate.instant("ASSIGNEDDATE"), name: "assignedDate" },
      { title: this.translate.instant("LASTUPDATE"), name: "lastdate" },
      { title: this.translate.instant("DUEDATE"), name: "duedate" }
    ];


    var selectSuppCode = [], userSuppCode, lineNos, selectLineNos = [];
    // Get Line number/next process selected by operation user
    if (this.userRoleId != 4) {
      lineNos = [];
    } else {
      if (this.lineNoFilter) {
        this.lineNoFilter.forEach(function (value, key) {
          selectLineNos.push(value.itemName);
        });

        if (selectLineNos.length > 0) {
          lineNos = selectLineNos;
        }
      }
    }

    if (lineNos == null) {
      lineNos = [];
    }

    //Get Selected Supplier Code
    if (this.userRoleId == 1) {
      userSuppCode = this.userDetJson.supplierCode;
    } else {
      if (this.supPoint) {
        this.supPoint.forEach(function (value, key) {
          selectSuppCode.push(value.itemName);
        });

        if (selectSuppCode.length > 0) {
          userSuppCode = selectSuppCode;
        }
      }
    }

    if (userSuppCode == null) {
      userSuppCode = [];
    }

    if (this.userRoleId == 4) {
      delete this.columns[1]
    }
    let dataToSend = {
      filteredDeliveryPoints: [],
      filteredLineNumbers: [],
      filteredSupplierCode: [],
      filteredSupplierName: [],
      lineNumbers: lineNos,
      pageNum: pageNo - 1,
      partStatus: partStatus,
      roleId: this.userRoleId,
      searchValue: this.searchText,
      size: this.itemsPerPage,
      sortColumn: '',
      sortType: 'ASC',
      supplierCodes: userSuppCode
    }

    this.spinner.show();
    this.data = [];
    this.rows = []

    this.logbaseService.partStatusWtPaging(dataToSend).subscribe(result => {
      this.parts = result;
      this.length = this.parts.response.totalElements;
      if (this.parts.response.content) {
        for (let index = 0; index < this.parts.response.content.length; index++) {
          this.data.push({
            partNumber: this.parts.response.content[index].partNumber,
            supplierCode: this.parts.response.content[index].supplierCode,
            partName: this.parts.response.content[index].partName,
            assignedDate: this.datePipe.transform(this.parts.response.content[index].assignedDate, 'yyyy-MM-dd'),
            lastdate: this.datePipe.transform(this.parts.response.content[index].dueDate, 'yyyy-MM-dd'),
            duedate: this.datePipe.transform(this.parts.response.content[index].updatedDate, 'yyyy-MM-dd')
          })
        }
        this.dataSource=new MatTableDataSource<NotificationData[]>(this.data)
      }
      this.spinner.hide();

    });
    this.rows = this.data;
    console.log("rows",this.rows)
    

  }

  public changePage(page: any, data: Array<any> = this.data) {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  public changeSort(data: any, config: any): any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter(data: any, config: any): any {
    let filteredData: Array<any> = data;
    this.columns.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns.forEach((column: any) => {
        if (item[column.name].toString().match(this.config.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    this.getPartWiseData(this.partStatus ? this.partStatus : 'new', page.page);
  }

  public onCellClick(data: any): any {
  }
}



